import Badge from "../../../components/ui/Badge";
import Field from "../../../components/ui/Field";
import { formatDate } from "../../../utils/date";
import { todayManilaKey } from "../../../utils/manilaTime";
import { cx } from "../../../utils/classNames";
import { getPersonName, isOverdue } from "../performanceUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Performance.module.css";

// `statusMap` is EMPLOYEE_STATUS or REVIEWER_STATUS depending on who is looking.
const EvaluationHeader = ({ evaluation, statusMap, showEmployee = false }) => {
  const status = statusMap[evaluation.status] ?? {
    label: evaluation.status,
    tone: "gray",
  };
  const overdue = isOverdue(evaluation, todayManilaKey());

  return (
    <div className={cx(ui.card, ui.cardPadded)}>
      <div className={ui.fieldGrid}>
        {showEmployee && (
          <>
            <Field label="Employee">{getPersonName(evaluation.employee)}</Field>
            <Field label="Branch">
              {evaluation.employee?.branch?.branchName}
            </Field>
          </>
        )}
        <Field label="Form">{evaluation.template?.name}</Field>
        <Field label="Period">{evaluation.periodLabel}</Field>
        <Field label="Evaluator">{getPersonName(evaluation.evaluator)}</Field>
        <Field label="Due">
          {evaluation.dueDate && (
            <span className={cx(overdue && styles.overdue)}>
              {formatDate(evaluation.dueDate)}
              {overdue && " · Overdue"}
            </span>
          )}
        </Field>
        <Field label="Status">
          <Badge tone={status.tone}>{status.label}</Badge>
        </Field>
      </div>
    </div>
  );
};

export default EvaluationHeader;
